import React from 'react';
import { Spacer, theme as uiTheme } from '../../index';
import {
  BannerWrapper,
  BannerInner,
  BannerAction,
  BannerIcon,
  BannerContent,
  BannerText,
} from '../Banner/Banner';
import { NotificationProps } from './NotificationProps';
import { TextProps } from '../../Atoms/Text/Text';

const containerStyle = () => ({
  boxShadow: `
    1px 1px 2px rgba(0, 0, 0, 0.04), 
    1px 4px 8px rgba(0, 0, 0, 0.08)
  `,
});

const innerstyle = ({ link }: { link?: string }) => ({
  userSelect: 'none',
  cursor: 'default',
  extend: [
    {
      condition: link,
      style: {
        cursor: 'pointer',
        textDecoration: 'none',
      },
    },
  ],
});

const NotificationTitle = ({ dmId, children, ...otherProps }: TextProps) => (
  <BannerText dmId={dmId} weight="bold" {...otherProps}>
    {children}
  </BannerText>
);

function Notification({
  dmId = 'dm-notification',
  id,
  icon,
  kind = 'neutral',
  title,
  message,
  link,
  onClose,
  ...otherProps
}: NotificationProps) {
  return (
    <div data-designsystem data-dmid={dmId} {...otherProps}>
      <BannerWrapper
        dmId={`${dmId}-wrapper`}
        kind={kind}
        style={containerStyle}>
        <BannerInner
          dmId={`${dmId}-inner`}
          as={link ? 'a' : 'div'}
          href={link}
          style={innerstyle({ link })}>
          <Spacer size={uiTheme.dimension.spacing.xxs.rem} />
          <BannerIcon
            id={`${id || dmId}-icon`} // todo: dmId should be removed, as soon as id prop is required (myt-7757)
            dmId={`${dmId}-icon-wrapper`}
            icon={icon}
            kind={kind}
          />
          <Spacer size={uiTheme.dimension.spacing.xxxs.rem} />
          <BannerContent dmId={`${dmId}-content`}>
            {title && (
              <>
                <NotificationTitle dmId={`${dmId}-title`}>
                  {title}
                </NotificationTitle>
                <Spacer size={uiTheme.dimension.spacing.xxxs.rem} />
              </>
            )}
            <BannerText dmId={`${dmId}-text`}>{message}</BannerText>
          </BannerContent>
          <Spacer size={uiTheme.dimension.spacing.xxs.rem} />
        </BannerInner>
        <BannerAction
          id={`${id || dmId}-action`}
          dmId={`${dmId}-action`}
          onClose={onClose}
        />
      </BannerWrapper>
    </div>
  );
}

export default React.memo(Notification);
